// extracted by mini-css-extract-plugin
export default {"feedback-tooltip-content":"FeedbackTooltip-module__feedback-tooltip-content-ZunN","internal":"FeedbackTooltip-module__internal-EnLZ"};